<template>
  <Modal :open.sync="open" size="large">
    <Chooser v-if="!choice" :value.sync="choice" />
    <LibrarySelector v-else-if="choice == 'library'" :value.sync="choice" />
    <TeamLibrarySelector v-else :value.sync="choice" />
  </Modal>
</template>

<script>
import { sync } from "vuex-pathify";
import Modal from "@/components/ui/Modal.vue";
import VButton from "@/components/ui/VButton.vue";
import Chooser from "./ImportListChooser.vue";
import LibrarySelector from "./LibrarySelector.vue";
import TeamLibrarySelector from "./TeamLibrarySelector.vue";

export default {
  data() {
    return {
      choice: false
    };
  },

  components: {
    Modal,
    VButton,
    Chooser,
    LibrarySelector,
    TeamLibrarySelector
  },

  computed: {
    open: sync("ui/modal@list.import.open")
  }
};
</script>